import { render, staticRenderFns } from "./ListRowsAreas.vue?vue&type=template&id=0c4fc949"
import script from "./ListRowsAreas.vue?vue&type=script&lang=js"
export * from "./ListRowsAreas.vue?vue&type=script&lang=js"
import style0 from "./ListRowsAreas.vue?vue&type=style&index=0&id=0c4fc949&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c4fc949')) {
      api.createRecord('0c4fc949', component.options)
    } else {
      api.reload('0c4fc949', component.options)
    }
    module.hot.accept("./ListRowsAreas.vue?vue&type=template&id=0c4fc949", function () {
      api.rerender('0c4fc949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/productiveAreas/detail/component/ListRowsAreas.vue"
export default component.exports